import ConfigService from "../services/configService";

const EnvConfig = {
  LOCAL: {
    API_URL: ConfigService.getApiUrl(),
  },
  DEV:{
    API_URL: "https://telepedido-dev-api.santillanaeducacao.com.br",
  },
  PRE:{
    API_URL: "https://telepedido-pre-api.santillanaeducacao.com.br",
  },
  PRODUCTION: {
    API_URL: "https://telepedido-api.santillanaeducacao.com.br",
  }
};
  
const getCurrentEnvConfig = () => {
  const hostname = window.location.hostname;

  if (hostname.includes("localhost")) {
      return EnvConfig.LOCAL.API_URL;
  } else if (hostname.includes("telepedido-dev")) {
      return EnvConfig.DEV.API_URL;
  } else if (hostname.includes("telepedido-pre")) {
      return EnvConfig.PRE.API_URL;
  } else {
      return EnvConfig.PRODUCTION.API_URL;
  }
};
  
export default getCurrentEnvConfig;
  